import React from 'react';
import { BsZoomOut } from "react-icons/bs";
import BarChartSoftdata from './BartChartSoftdata';

const BarChartDrillDownReports = (props) => {
    // Extração limpa das props
    const { data, line, precision, onClickEventHandler } = props;

    // PROTEÇÃO 1: Garantir que a 'data' existe e não está vazia
    if (!data || data.length === 0) return null;

    const barData = [];
    
    // Comparação super segura usando String e trim()
    const row = data.find((l) => String(l.linha).trim() === String(line).trim());

    // PROTEÇÃO 2: Se não encontrar a linha, pára aqui sem crashar
    if (!row || !row.reportResultsByColumn) return null;

    const columns = row.reportResultsByColumn.filter((c)=> String(c.coluna).trim() !== 'TOTAL');
    
    // Precisão fallback (se a props não chegar, usa 1)
    const precisaoUsada = precision !== undefined ? precision : 1;
    
    for (let i = 0; i < columns.length; i++) {
        // Garantir que a chave name não tem espaços estranhos
        const nomeColuna = String(columns[i].coluna).trim();
        
        // Converter para número em vez de String
        const valorRaw = Number(columns[i].ph) || 0;
        
        // toFixed devolve string, parseFloat converte novamente para Número Real
        const phFloat = parseFloat(valorRaw.toFixed(precisaoUsada));

        barData.push({
            name: nomeColuna,
            "% horizontal": phFloat
        });
    }
    
    return (
        <div>
            <h6 style={{ textAlign: "right" }}>Percentagens horizontais (%)</h6>
            <h4>{line}</h4>
            <br/>
            <BarChartSoftdata 
                handleBarClick={onClickEventHandler}
                nomeY={"% horizontal"} 
                barData={barData} 
            />
            <center>
                <BsZoomOut 
                    style={{fontSize: "32px", cursor: "pointer"}} 
                    onClick={onClickEventHandler} 
                    title="Voltar ao gráfico principal"
                    onMouseOver={({target})=>target.style.color="gray"}
                    onMouseOut={({target})=>target.style.color="black"}
                />
            </center>
        </div>
    );
};

export default BarChartDrillDownReports;